import type { IPagedResponse, PaginationParam } from '@/features/api/extranet'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'
import { urlEncodeQuery } from '@/features/shared/tools'
import type { NotificationStatutDTO } from '@/features/api/extranet/dto/Notification/NotificationStatutDTO';
import type { NotificationPayloadDTO } from '@/features/api/extranet/dto/Notification/NotificationPayloadDTO';

export async function loadAllNotifications<TResponse extends object>(
  withSablierAndDialog: boolean
): Promise<IPagedResponse<TResponse>> {
  const queryPagination: PaginationParam = {
    pageNumber: 0,
    pageSize: 50,
  }
  const queryString = urlEncodeQuery({
    statuts: ['Read', 'Unread'],
    ...queryPagination,
  })

  const fetch = useFetch('extranet')
  const response = await fetch(`/notifications/${queryString}`, {
    sablier: withSablierAndDialog ? true : false,
    dialogMode: withSablierAndDialog ? 'retry' : 'silent'
  })
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IPagedResponse<TResponse>

  return result
}

export async function loadUnreadNotifications<TResponse extends object>(
  withSablierAndDialog: boolean
): Promise<IPagedResponse<TResponse>> {
  const queryPagination: PaginationParam = {
    pageNumber: 0,
    pageSize: 50,
  }
  const queryString = urlEncodeQuery({
    statuts: ['Unread'],
    ...queryPagination,
  })

  const fetch = useFetch('extranet')
  const response = await fetch(`/notifications/${queryString}`, {
    sablier: withSablierAndDialog ? true : false,
    dialogMode: withSablierAndDialog ? 'retry' : 'silent'
  })
  ensureSuccessStatusCode(response)
  const result = (await response.json()) as IPagedResponse<TResponse>

  return result
}

export async function changeSingleNotificationStatus(payload: NotificationPayloadDTO, init?: RequestInit) {
  if (!init) init = { sablier: true, dialogMode: 'retry' }

  const request: RequestInit = {
    ...init,
    method: 'PUT',
    body: JSON.stringify(payload),
  }

  const fetch = useFetch('extranet')
  const response = await fetch(`/notifications`, request)
  ensureSuccessStatusCode(response)
}

export async function markAllNotificationsAs(statut: NotificationStatutDTO, init?: RequestInit) {
  if (!init) init = { sablier: true, dialogMode: 'retry' }

  const payload = {
    "IdsNotification": [],
    "StatutTo": statut,
    "statutsFrom": statut === 'Read' ? ["Unread"] : ["Read"]
  } as NotificationPayloadDTO

  const request: RequestInit = {
    ...init,
    method: 'PUT',
    body: JSON.stringify(payload),
  }

  const fetch = useFetch('extranet')
  const response = await fetch(`/notifications`, request)
  ensureSuccessStatusCode(response)
}

